import { COURIER_PORTAL_URL } from "@/config/app";

/**
 * Generate a tracking link for an order.
 * Returns null if no tracking portal URL is configured.
 */
export const getOrderLink = (code) => {
    if (!COURIER_PORTAL_URL || !code) return null;
    return COURIER_PORTAL_URL + code;
};
